import moment from "moment";
import { consumerLine, isGitchaConsumer } from "@/components/GitchaConsumerTag";

export const FILTERS = [
  { key: "all", label: "All" },
  { key: "unread", label: "Unread" },
  { key: "received", label: "Received", title: "Introductions to your Buyer Want-Listings" },
  { key: "sent", label: "Sent", title: "Introductions you sent" },
  { key: "direct", label: "Direct" },
];

const toMillis = (value) => {
  if (!value) return null;
  if (typeof value.toMillis === "function") return value.toMillis();
  if (typeof value.toDate === "function") return value.toDate().getTime();
  if (typeof value === "object" && typeof value.seconds === "number") return value.seconds * 1000;
  const time = new Date(value).getTime();
  return Number.isNaN(time) ? null : time;
};

export const directChatId = (me, other) =>
  Number(me) < Number(other) ? `${me}_${other}` : `${other}_${me}`;

const fullName = (first, last) => [first, last].filter(Boolean).join(" ").trim();

export const introRow = (intro, me) => {
  const iOwnTheWantListing = String(intro.wantAdCreatedId) === String(me);
  const awaitingReply = !iOwnTheWantListing && intro.isrepiled === false;
  const name = iOwnTheWantListing
    ? intro.invetroyUserName || "Agent"
    : fullName(intro.wantAdCreatedUserFirstName, intro.wantAdCreatedUserLastName) || "Agent";
  const firstName = name.split(" ")[0];
  const lastFromMe = String(intro.lastestMessageSentUserId) === String(me);
  return {
    key: `intro-${intro.introductionId}`,
    kind: "intro",
    direction: iOwnTheWantListing ? "received" : "sent",
    id: intro.introductionId,
    name: awaitingReply ? "Buyer's agent" : name,
    photo: awaitingReply ? "" : iOwnTheWantListing ? intro.inventoryCreatedUserImage : intro.wantAdCreatedUserImage,
    context: iOwnTheWantListing
      ? intro.inventoryLocation || "A property for your Buyer Want-Listing"
      : intro.wantAdText || "Their Buyer Want-Listing",
    preview: intro.latestMessage
      ? `${lastFromMe ? "You" : firstName}: ${intro.latestMessage}`
      : "",
    awaitingReply,
    unread: iOwnTheWantListing
      ? intro.isWantAdOwnerHasUnreadMessage === true
      : intro.isInventoryOwnerHasUnreadMessage === true,
    time: toMillis(intro.createdat),
    pending: !intro.createdat,
    intro,
  };
};

export const directRow = (chat, me, unreadIds = []) => ({
  key: `dm-${chat.userId}`,
  kind: "direct",
  direction: "direct",
  id: chat.userId,
  name: fullName(chat.firstName, chat.lastName) || "Member",
  photo: chat.profileUrl || "",
  context: isGitchaConsumer(chat) ? consumerLine(chat.source) : "Direct message",
  preview: chat.lastMessage || "",
  awaitingReply: false,
  unread: unreadIds.includes(directChatId(me, chat.userId)),
  time: toMillis(chat.lastMessageAt),
  pending: false,
  chat,
});

export const liveIntros = (intros) =>
  (intros || []).filter((item) => item.isaccepted == true && item.isdeleted == false);

export const buildRows = ({ intros, chats, me, unreadIds }) => [
  ...liveIntros(intros).map((intro) => introRow(intro, me)),
  ...(chats || []).filter((chat) => chat.userId).map((chat) => directRow(chat, me, unreadIds)),
];

export const sortRows = (rows) => [...rows].sort((a, b) => (b.time || 0) - (a.time || 0));

export const filterRows = (rows, filter, term = "") => {
  const words = term.trim().toLowerCase();
  return rows.filter((row) => {
    if (filter === "unread" && !row.unread) return false;
    if (filter === "received" && row.direction !== "received") return false;
    if (filter === "sent" && row.direction !== "sent") return false;
    if (filter === "direct" && row.kind !== "direct") return false;
    if (!words) return true;
    return `${row.name} ${row.context} ${row.preview}`.toLowerCase().includes(words);
  });
};

export const shortTime = (millis, now = Date.now()) => {
  if (!millis) return "";
  const time = moment(millis);
  const today = moment(now);
  if (time.isSame(today, "day")) return time.format("h:mm A");
  if (time.isSame(today.clone().subtract(1, "day"), "day")) return "Yesterday";
  if (today.diff(time, "days") < 7) return time.format("ddd");
  if (time.isSame(today, "year")) return time.format("MMM D");
  return time.format("MMM D, YYYY");
};

export const TONES = 5;
export const toneOf = (name = "") =>
  [...name].reduce((sum, char) => sum + char.charCodeAt(0), 0) % TONES;
export const initialsOf = (name = "") =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join("");
